import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewMedal = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('gamification-management/medal', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getMedal = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('gamification-management/medal/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addMedal = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('gamification-management/medal/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editMedal = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('gamification-management/medal/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
